export const notNullString = (text : any) : string => {
    if(text && text != null ){
        return text;
    }
    return '';
}
export const replaceLongStringToPoints = (text: any, sizeToShow: number): string => {
    let textLocal = notNullString(text);
    if(textLocal.length > sizeToShow){
        textLocal = textLocal.substring(0,sizeToShow);
        textLocal = textLocal + "...";
    }
    return textLocal;
}

export const toUpperCaseUtil = ( text: string | undefined) => {
    let textLocal = notNullString(text);
    return textLocal.toUpperCase();
}

export const upperCaseFirstLetter = ( text: string | undefined) => {
    let textLocal = notNullString(text);
    textLocal  = toUpperCaseUtil(textLocal.substring(0,1)) + textLocal.substring(1);
    return textLocal;
}